module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/edit-widget-modal/widget-setting/widget-setting.component.scss
// module id = ./src/app/widgets/edit-widget-modal/widget-setting/widget-setting.component.scss
// module chunks = main